// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3270":"442609e5","3509":"083187dd","6952":"60e2babe","7566":"def30d8f"}[chunkId] + ".chunk.css";
};